import shareHelper from "@/helper/shareHelper";
import {
  AddOptionExportProductToIndexedDB,
  ClearOptionExportProductFromIndexedDB,
  DeleteOptionExportProductFromIndexedDB,
  GetOptionExportProductFromIndexedDB,
} from "@/IndexedDB/optionExportIndexedDB";

const prefixKeyCookie = "optionsExport-";

// #region OptionExportDocument
export const GetOptionExportKeyIndexedDB = (merchantId, financeType, transactionType, transactionItemType) => {
  const keyOption = `${merchantId ? merchantId : ""}${financeType ? financeType : ""}${
    transactionType ? transactionType : ""
  }${transactionItemType ? transactionItemType : ""}`;
  const keyOptionExport = `${prefixKeyCookie}${btoa(keyOption)}`;
  return keyOptionExport;
};
// #endregion

// #region OptionExportProduct
function GetOptionExportProductIndexedDBKey(merchantId, userId) {
  return `option_export_product:${merchantId}:${userId}`;
}

export const AddOptionExportProductToDB = async (merchantId, userId, optionExportProduct) => {
  const key = GetOptionExportProductIndexedDBKey(merchantId, userId);
  await AddOptionExportProductToIndexedDB(key, optionExportProduct);
};

export const GetOptionExportProductFromDB = async (merchantId, userId) => {
  const key = GetOptionExportProductIndexedDBKey(merchantId, userId);
  return await GetOptionExportProductFromIndexedDB(key);
};

export const DeleteOptionExportProductFromDB = async (merchantId, userId) => {
  const key = GetOptionExportProductIndexedDBKey(merchantId, userId);
  await DeleteOptionExportProductFromIndexedDB(key);
};

export const ClearOptionExportProductFromDB = async () => {
  await ClearOptionExportProductFromIndexedDB();
};
// #endregion

export const ClearOptionsExportFromCookie = () => {
  try {
    const cookies = document.cookie ? document.cookie.split(";") : [];
    cookies.forEach((cookie) => {
      const cookieParts = cookie.split("=");
      if (cookieParts.length > 0) {
        const cookieName = cookieParts[0].trim();
        if (cookieName.startsWith(prefixKeyCookie)) {
          shareHelper.DeleteCookie(cookieName);
        }
      }
    });
  } catch (error) {}
};
